import { clampFrameToCanvas, type CanvasFrame } from "@refinement-canvas/domain";

// 当初仕様（キャンバス外にも図形を配置可）へ戻したため、アスペクト比固定リサイズでも位置・サイズを
// キャンバス矩形へ収める処理は行わない。比率維持そのものは呼び出し側（use-resize-handle）が担うため、
// ここは数値サニタイズ（clampFrameToCanvas＝有限化・w/h 非負化）に委ねるだけとする。
// 呼び出し側の差し替えを最小化するため、関数自体は残す（実体はサニタイズのみ）。
export function clampAspectFrameToCanvas<T extends CanvasFrame>(frame: T): T {
  return clampFrameToCanvas(frame);
}
